import React from 'react';
import { IconAppendWrapper } from '../../styled';
import { LoadingIndicator } from '../../../loading-indicator';
import { Icon } from '../../../icon';
import { Button } from '../../../button';
const renderIndicator = (condition, element) => condition ? React.createElement(IconAppendWrapper, null, element) : null;
export const IndicatorsContainer = ({ appendInnerIcon, isLoading, disabled, onClear, isClearable, showClearButton, size }) => {
    return (React.createElement(React.Fragment, null,
        renderIndicator(isLoading, React.createElement(LoadingIndicator, null)),
        renderIndicator(isClearable && showClearButton, React.createElement(Button, { onClick: onClear, variant: "transparent", StartIcon: React.createElement(Icon, { name: "close_outline" }), "data-testid": "date-picker-clear-button" })),
        appendInnerIcon && (React.createElement(IconAppendWrapper, { "$disabled": disabled, "$size": size }, appendInnerIcon))));
};
